angular.module('common.directives').directive('edgeTrip', function () {
  return {
    scope: {
      edge: '='
    },
    templateUrl: './templates/edgeTrips.view.html?t=' + webpackHash,
    link: function ($scope, $element) {},
    controller: 'edgeTripsController'
  }
})
